import axiosInstance from './../providers/Axios';

import { logoutUser } from '../config/paths';

export const callLogoutUser = async () => {
  return axiosInstance({
    url: logoutUser,
    method: 'post',
  });
};
